<template>
  
    <div class="h-full w-full lg:mt-40">
  
  
           <div class="h-full w-full ">
  
               <transition name="fade" appear class="bg-pink-400 h-1/2 w-full bg">
                  <div class="h-full w-full flex justify-center items-center">
                      
                      <div class="flex flex-row justify-between items-center h-screen w-full">
  
                          <locations-map :slots="modalSlots" :showOnlyTheOneSlot="showOnlyTheOneSlot" :oneSlot="oneSlot"
                          :dayDate="dayDate" :setHighlighted="setHighlighted"
                          :refreshedMap="refreshedMap"/>
                      </div>
                  </div>
              </transition>
          </div>

           <div v-if="highLightedSlotsList.length > 0" class="mySessionsDivider p-1 mt-4 mb-10">
  
              <div v-for="(highLightedSlot,index) in highLightedSlotsList" :key="index"
              class="myCardDiv">
  
                  <session-card :email="email" :key="highLightedSlot.id" :showDescription="showDescription"
                 :myReload="myReload" :isCard="true" :showClassPage="showClassPage"
                  :mySlot="highLightedSlot" :index="index" :dayDate="dayDate" />
              </div> 
          </div>  
    </div>
  </template>
  
  <script>
  
  import LocationsMap from './SessionsLocationsMap.vue';
  
  // import LocationsMapCard from './LocationsMapCard'
  
  import SessionCard from './SessionCard.vue';
  
  export default {
  
      mounted(){
  
          // console.log(`in sessions map modal`);
          // this.highLightedSlot = this.modalSlots[0];
      },
  
      props:{
  
          refreshedMap: 0,
            
          showClassPage: {
  
              type: Function
          },
  
          showOnlyTheOneSlot: false,
  
          oneSlot: {
  
              type: Object
          },
  
          myReload: {
  
              type: Function
          },
  
  
           displayModal: {
  
              type: Function
          },
  
          showDescription:{
  
              type: Function
          },
  
          email: '',
  
          isCard: false,
  
          userId: 0,
  
          dayDate: '',
  
          changeShowModal:{
  
              type: Function
          },
  
  
          // modalLocations: {
          modalSlots: {
              type: Array 
          },
  
          showModal: false,
      },
  
      components: {
  
      LocationsMap,
      SessionCard
      // LocationsMapCard,
      
      // SessionInfoOrCard
      },
  
      methods:{
  
  
          setHighlighted(slot, index){
  
              this.index;
              // Vue.set (this.highLightedSlot, slot);
              // this.highLightedSlot = slot;
              this.highLightedSlotsList = this.modalSlots.filter(item => item.class.location.id == slot.class.location.id);
  
  
              // console.log(`highLightedSlotsList: ${JSON.stringify(this.highLightedSlotsList)}`);
          },
  
  
      },
  
      data: function(){
  
          return{
  
              displayingImage: '',
  
              // highLightedSlot: null,
              highLightedSlotsList: [],
              
              // inModalImages: [],
  
              index: 0,
          }
      },
  
  
  }
  </script>
  
  <style>
  
  
      /* a {
      text-decoration: none;
      display: inline-block;
      padding: 8px 16px;
      }
  
      a:hover {
      background-color: #fbb6ce;
      color: white;
      }
  
      .previous {
      background-color: #ed64a6;
      color: white;
      }
  
      .next {
      background-color: #ed64a6;
      color: white;
      }
  
      .round {
      border-radius: 50%;
      } */
  
  @media screen and (max-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
  
          top: 25%;
  
      }
  }
  
  @media screen and (min-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
  
  /* transform: translate(50%, 50%); */
  
          top: 25%;
          left: 25%;
      }
  
  }
  </style>